module.exports = __webpack_public_path__ + "img/play.ea9cf4e9.png";